// extracted by mini-css-extract-plugin
module.exports = {"drawer":"styles_drawer__1FXJf","closeIcon":"styles_closeIcon__asoSR"};